import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DialogiMediatuotanto({
  backgroundImageUrl = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/kuva_laaja_100.png"
}: {
  backgroundImageUrl?: string;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="home" className="relative h-[599px] w-[1448px] max-w-[90vw] aspect-[1448/599] mx-auto overflow-hidden flex flex-col justify-center items-center px-6 py-6 md:py-12 lg:py-16 bg-background bg-cover bg-center !bg-[url(https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Kuva-laaja-70c.jpg)]" style={{
    backgroundImage: `url(${backgroundImageUrl})`
  }}>
      <div className="absolute inset-0 bg-white/65 z-0" />

      <div ref={ref} className={`relative z-10 w-full max-w-5xl mx-auto flex flex-col items-center justify-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="flex justify-center mb-4 md:mb-6 w-full">
          <Link to="/" className="inline-block w-[75%] md:w-[60%] lg:w-[50%] max-w-[620px]">
            <img src="https://dialogimediatuotanto.com/wp-content/uploads/2026/06/dialogilogo-teksti.png" alt="Dialogi Mediatuotanto logo" className="w-full h-auto object-contain" />
          </Link>
        </div>

        <p className="font-sans text-sm md:text-lg tracking-[0.15em] uppercase mb-2 md:mb-6 w-[90%] md:w-full mx-auto text-[#243A63]">
          Videoita, musiikkia ja tarinankerrontaa
        </p>

        <p className="font-sans text-base md:text-xl lg:text-2xl text-[#243A63] font-light w-[88%] md:w-[70%] max-w-3xl mx-auto leading-relaxed mb-8 md:mb-12 bg-white/6 backdrop-blur-sm rounded-lg p-4 md:p-8">
          Luomme videoita, musiikkia ja mediasisältöjä, jotka tekevät paikoista, ihmisistä ja yhteisöistä muistettavia.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button size="lg" className="h-10 inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs rounded-md has-[>svg]:px-4 bg-primary text-primary-foreground text-lg font-bold min-w-[240px] !h-[48px] ![padding:24px_32px_28px_32px] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90" onClick={e => {
          e.preventDefault();
          document.getElementById("yhteystiedot")?.scrollIntoView({
            behavior: "smooth"
          });
        }}>
            Ota yhteyttä
          </Button>

          <Button variant="outline" className="min-w-[240px] font-bold bg-transparent text-[#243A63] border-[#243A63] border-2 hover:bg-[#243A63]/10 text-lg group h-[48px] px-8 rounded-md" onClick={e => {
          e.preventDefault();
          document.getElementById("palvelut")?.scrollIntoView({
            behavior: "smooth"
          });
        }}>
            Tutustu palveluihin
          </Button>
        </div>
      </div>
    </section>;
}